import {
  FetchTaskCacheKey,
  TaskGqlError,
  TaskUUID,
  UpdateTaskGqlQuery,
  UpdateTaskGqlStatus
} from '../../tasksTypes';

import { useUpdateQuery } from '../../../common/reactQuery/hooks/useUpdateQuery';

interface ContinueTaskOptions {
  query: UpdateTaskGqlQuery;
  cacheKeys?: FetchTaskCacheKey[];
}

export interface ContinueTaskResponse<ContinueTaskRecordType> {
  continueTask: {
    status: UpdateTaskGqlStatus;
    recordUuid: TaskUUID;
    record: ContinueTaskRecordType;
    errors: ContinueTaskError;
  };
}

export interface ContinueTaskInput {
  uuid: TaskUUID;
}

export interface ContinueTaskError {
  fullMessages: TaskGqlError;
}

const action = 'continueTask';

const scope = 'task';

const pluralScope = 'tasks';

function useContinueTask<ContinueTaskRecordType>({
  query,
  cacheKeys
}: ContinueTaskOptions) {
  const {
    updateQueryData,
    updateQuery,
    updateQueryReset,
    updateQueryError,
    updateQueryLoading,
    updateQueryErrorMessage
  } = useUpdateQuery<
    ContinueTaskInput,
    ContinueTaskResponse<ContinueTaskRecordType>,
    ContinueTaskError,
    ContinueTaskRecordType
  >({ action, pluralScope, scope, query, cacheKeys });

  return {
    continueTaskData: updateQueryData,
    continueTaskError: updateQueryError,
    continueTaskLoading: updateQueryLoading,
    continueTaskErrorMessage: updateQueryErrorMessage,
    continueTask: updateQuery,
    continueTaskReset: updateQueryReset
  };
}

export default useContinueTask;
